// Mock data for House Of Fitness website

export const gymInfo = {
  name: "House Of Fitness",
  tagline: "חדר כושר שנולד מתוך תשוקה",
  description: "חדר כושר שנולד מתוך תשוקה לעולם הספורט בכל התחומים תוך שיתוף פעולה עם אנשי מקצוע מעולים המתמחים בתחומים וסוגי ספורט שונים על מנת לתת למתאמן חווית משתמש ומגוון שירותים שלא נראו במחוזותינו וכל זה במבנה קסום השוכן באחד מהמקומות היפים בארץ.",
  logo: "https://customer-assets.emergentagent.com/job_d5ddfdf6-d2ae-4760-94a7-fbb6b450b35e/artifacts/xz26jwij_image.png",
  phone: "050-276-8005",
  address: "רחוב המייסדים 51, זכרון יעקב, 3091085",
  email: "hof.zyc@gmail.com",
  membershipUrl: "https://hof.web.arboxapp.com/membership?whitelabel=HOUSEOFFITNESSZY&lang=he&referrer=site&location=14383",
  instagram: "https://instagram.com/hof.zy",
  spotify: "https://open.spotify.com/user/31cfegytifoxhac54oatrv5yw6ji?si=c25e4602f80f4a07&nd=1&dlsi=46f662ac14774f6c",
  appStore: "https://apps.apple.com/il/app/house-of-fitness-zy/id6470148624",
  facebook: "#",
  hours: {
    sunday: "6:30 - 23:00",
    monday: "6:30 - 23:00",
    tuesday: "6:30 - 23:00",
    wednesday: "6:30 - 23:00",
    thursday: "6:30 - 23:00",
    friday: "7:00 - 19:00",
    saturday: "9:00 - 13:00, 16:00 - 22:00"
  }
};

export const features = [
  {
    id: 1,
    title: "חנייה חינם",
    description: "חנייה חינם למנויים במרכז המושבה",
    icon: "parking-circle"
  },
  {
    id: 2,
    title: "שעות פתיחה נוחות",
    description: "פתוח 7 ימים בשבוע בשעות נוחות",
    icon: "clock"
  },
  {
    id: 3,
    title: "אתגרים ופרסים",
    description: " השתתפות באתגרים וזכיה בפרסים שווים",
    icon: "trophy"
  },
  {
    id: 4,
    title: "מגוון אימונים",
    description: "אימוני כוח, יוגה ופילאטיס קבוצתיים ואישיים",
    icon: "dumbbell"
  },
  {
    id: 5,
    title: "קליניקת שיקום",
    description: "קליניקת מומחים לשיקום וליווי תזונתי",
    icon: "heart-pulse"
  },
  {
    id: 6,
    title: "בריא-לי בר",
    description: "בר בריאות עם מגוון שייקים מאכלים בריאים ומשקאות חלבון",
    icon: "coffee"
  },
  {
    id: 7,
    title: "מקלחות מפנקות",
    description: "מקלחות נקיות עם כל מה שתצטרכו",
    icon: "shower-head"
  },
  {
    id: 8,
    title: "יחס אישי",
    description: "יחס אישי וליווי מקצועי מהמאמנים הטובים בארץ",
    icon: "user-check"
  }
];

export const services = [
  {
    id: 1,
    title: "אימונים אישיים",
    description: "אימון אישי מותאם אישית עם מאמנים מקצועיים שילוו אותך לאורך כל הדרך להשגת היעדים שלך",
    image: "https://instagram.ftlv18-1.fna.fbcdn.net/v/t51.75761-15/488582479_17942477138994534_829197503865661788_n.jpg?stp=dst-jpg_e35_tt6&_nc_cat=111&ig_cache_key=MzYwNjAyOTc2MTY4MzQ2ODgzNA%3D%3D.3-ccb7-5&ccb=7-5&_nc_sid=58cdad&efg=eyJ2ZW5jb2RlX3RhZyI6InhwaWRzLjEzNTB4MTY4Ny5zZHIuQzMifQ%3D%3D&_nc_ohc=-U6LOwiIqXgQ7kNvwGwZFxL&_nc_oc=AdkXWc7yQKuAvhVp4syEk1Ji9diqy1k2UqykWyov72m6M8Qk0OItk9E09wVfPOuMZ8o&_nc_ad=z-m&_nc_cid=0&_nc_zt=23&_nc_ht=instagram.ftlv18-1.fna&_nc_gid=ZNfeSSdTGouPWPLUYBeBgw&oh=00_Afsz55s7nhlHYVSBdcIqWNeSKKqQSW2lUhmO3Ssf8t1Cyw&oe=69911309",
    icon: "user"
  },
  {
    id: 2,
    title: "אימונים קבוצתיים",
    description: "אימוני קבוצה אנרגטיים ומגוונים המשלבים כוח, סיבולת ועבודת צוות באווירה מעוררת מוטיבציה",
    image: "https://instagram.fsdv1-2.fna.fbcdn.net/v/t39.30808-6/469006060_17926795175994534_5480766988774427350_n.jpg?stp=dst-jpg_e35_p640x640_sh0.08_tt6&_nc_cat=100&ig_cache_key=MzM0ODM2MzY4NTk2MjgzMjM5Mg%3D%3D.3-ccb7-5&ccb=7-5&_nc_sid=58cdad&efg=eyJ2ZW5jb2RlX3RhZyI6InhwaWRzLjE0NDB4MTgwMC5zZHIuQzMifQ%3D%3D&_nc_ohc=wXJR3j7lMoQQ7kNvwGbtOp-&_nc_oc=AdmEruM0yzUJoHvDPL6HgNXyQ6P3i8ubMlxcKF4HgHNmr_quoDO7fsoQJiEEYLuu8no&_nc_ad=z-m&_nc_cid=0&_nc_zt=23&_nc_ht=instagram.fsdv1-2.fna&_nc_gid=-p0UNJTbJwFx6o2mhNSJdg&oh=00_AfurjYqTqoxVIz30jtp9KUZ92TdqBvByS-D3I7gVcvngiw&oe=699114CA",
    icon: "users"
  },
  {
    id: 3,
    title: "פילאטיס ויוגה",
    description: "שיעורי פילאטיס ויוגה מקצועיים לחיזוק הליבה, שיפור הגמישות והיציבה עם ציוד מתקדם",
    image: "https://instagram.ftlv18-1.fna.fbcdn.net/v/t51.75761-15/489304781_17942741420994534_5990774466911124089_n.jpg?stp=dst-jpg_e35_p1080x1080_tt6&_nc_cat=107&ig_cache_key=MzYwNzg0MTI1Njk2MDU1NDI5OQ%3D%3D.3-ccb7-5&ccb=7-5&_nc_sid=58cdad&efg=eyJ2ZW5jb2RlX3RhZyI6InhwaWRzLjEzNTB4MTY4Ny5zZHIuQzMifQ%3D%3D&_nc_ohc=CK38LjJaVAAQ7kNvwENoX8c&_nc_oc=AdlCjZZbnQu68PK6d5SYQ8rYJXEpGJ0LFfXHx0BTvTLyaTmOQ_WGcZQKLz8R_E4daCk&_nc_ad=z-m&_nc_cid=0&_nc_zt=23&_nc_ht=instagram.ftlv18-1.fna&_nc_gid=ZNfeSSdTGouPWPLUYBeBgw&oh=00_Afva1aPsAFyBgKHToPwgIHvc5UiA4oP8W_0DZOF2KuXjFQ&oe=6991007C",
    icon: "activity"
  },
  {
    id: 4,
    title: "אימוני נוער",
    description: "תוכניות אימון מיוחדות לנוער המותאמות לגיל ולצרכים הפיזיולוגיים בדגש על טכניקה נכונה",
    image: "https://customer-assets.emergentagent.com/job_fitness-zion/artifacts/753jrwpj_image.png",
    icon: "target"
  },
  {
    id: 5,
    title: "ייעוץ תזונאי",
    description: "ליווי תזונתי מקצועי להשגת יעדים, בניית תפריטים אישיים ושיפור הרגלי האכילה",
    image: "https://customer-assets.emergentagent.com/job_d5ddfdf6-d2ae-4760-94a7-fbb6b450b35e/artifacts/knv6oet2_image.png",
    icon: "apple"
  }
];

export const gallery = [
  {
    id: 1,
    image: "https://customer-assets.emergentagent.com/job_d5ddfdf6-d2ae-4760-94a7-fbb6b450b35e/artifacts/rkz4p3eb_image.png",
    alt: "אולם האימונים הראשי"
  },
  {
    id: 2,
    image: "https://customer-assets.emergentagent.com/job_d5ddfdf6-d2ae-4760-94a7-fbb6b450b35e/artifacts/1qmy7ef3_image.png",
    alt: "אזור המשקולות"
  },
  {
    id: 3,
    image: "https://customer-assets.emergentagent.com/job_d5ddfdf6-d2ae-4760-94a7-fbb6b450b35e/artifacts/knv6oet2_image.png",
    alt: "אזור הדמבלים"
  },
  {
    id: 4,
    image: "https://customer-assets.emergentagent.com/job_d5ddfdf6-d2ae-4760-94a7-fbb6b450b35e/artifacts/6sa8vlol_image.png",
    alt: "המבנה מבחוץ"
  },
  {
    id: 5,
    image: "https://customer-assets.emergentagent.com/job_fitness-zion/artifacts/k89ge9n3_image.png",
    alt: "אזור האימונים המרכזי"
  },
  {
    id: 6,
    image: "https://customer-assets.emergentagent.com/job_fitness-zion/artifacts/753jrwpj_image.png",
    alt: "אזור הכוח והמשקולות"
  }
];

export const testimonials = [
  {
    id: 1,
    name: "איתי ברנר",
    rating: 5,
    text: "מקום נהדר ומואר עם נוף למושבה. אף פעם לא עמוס מדי והמדריכים מקצועיים."
  },
  {
    id: 2,
    name: "יהונתן מ.",
    rating: 5,
    text: "חדר כושר פצצה אווירה אמיתית כל המאמנים סופר נחמדים גם ברי לי בר ממול אששש הבעלים נמצא אחלה בחור"
  },
  {
    id: 3,
    name: "עידו בוהנדה",
    rating: 5,
    text: "מקום שהוא בית אווירה מקצועיות וסדר ונקיון"
  }
];

export const trainers = [
  {
    id: 1,
    name: "ליהיא בן אבי",
    title: "מאמנת כושר מוסמכת",
    specialty: "אימוני כוח",
    image: "https://instagram.fhfa1-1.fna.fbcdn.net/v/t51.82787-15/535837735_17958304304994534_2627237805232204584_n.jpg?stp=dst-jpg_e35_tt6&_nc_cat=109&ig_cache_key=MzcwMzI5MzM4MDYwNjk2MDg0Mw%3D%3D.3-ccb7-5&ccb=7-5&_nc_sid=58cdad&efg=eyJ2ZW5jb2RlX3RhZyI6InhwaWRzLjE0NDB4MTkyMC5zZHIuQzMifQ%3D%3D&_nc_ohc=BQ8Z3BzwwTwQ7kNvwFmH55y&_nc_oc=Adl4pwjtHgeMAI2osIK2sXYxn4IlnGSM2ESGYqHxO7dbzqii9R4j62t5T4NE1KHKC5U&_nc_ad=z-m&_nc_cid=0&_nc_zt=23&_nc_ht=instagram.fhfa1-1.fna&_nc_gid=dekduVW07A-lKCfJnSfFwQ&oh=00_AfsHgb7U-o6WXDsqeRXQ82NX36aiqw2jZjBfIIM07nRiSA&oe=698E6025",
    bio: "מדריכת כושר צבאית, מתמחה באימוני כוח קבוצתיים ואימונים פונקציונליים"
  },
  {
    id: 2,
    name: "יהונתן דהן",
    title: "מאמן כושר מוסמך",
    specialty: "פאוורליפטינג",
    image: "https://instagram.fhfa1-1.fna.fbcdn.net/v/t51.75761-15/471666672_17929426982994534_3631419662602063038_n.jpg?stp=dst-jpg_e35_tt6&_nc_cat=107&ig_cache_key=MzUzMDA1NDQ1NTcwNTgxMzE2OA%3D%3D.3-ccb7-5&ccb=7-5&_nc_sid=58cdad&efg=eyJ2ZW5jb2RlX3RhZyI6InhwaWRzLjEzNTB4MTY4Ny5zZHIuQzMifQ%3D%3D&_nc_ohc=L2VOj8iOJaoQ7kNvwGsXGoG&_nc_oc=Adk8k8MUJcry8A37S6Ga9z7MqthGK0VuT_s3Kz8iBOhSOL3D_ZQWc0vENm-hTWhvRAI&_nc_ad=z-m&_nc_cid=0&_nc_zt=23&_nc_ht=instagram.fhfa1-1.fna&_nc_gid=WkXln6kn1HwZLT47QKBEHQ&oh=00_Aft22OIB78vNFmOgQM2zHZXqD1MqvxRFfBZATV8KSZqPng&oe=698E6F9F",
    bio: "פאוורליפטר עם רקע בשחייה ורכיבת אופניים מקצועית, ומצטיין בקורס מדריכים בוינגייט, יהונתן מלווה מתאמנים בגילאי 14-70 המגיעים משלל רקעים ורמות ניסיון שונות. כשעובדים עם יהונתן, גם בלי ניסיון אימונים קודם, 150 ק״ג סקוואט או 100 ק״ג בנץ׳ בפחות משנה זה ממש לא מופרך!"
  },
  {
    id: 3,
    name: "גל ברקאי",
    title: "מאמן כושר מוסמך",
    specialty: "ליווי אישי",
    image: "https://instagram.ftlv1-1.fna.fbcdn.net/v/t51.75761-15/470899778_17929296581994534_3859062817146519164_n.jpg?stp=dst-jpg_e35_tt6&_nc_cat=104&ig_cache_key=MzUyOTM0NzcyMDgyNTM3NTEzNw%3D%3D.3-ccb7-5&ccb=7-5&_nc_sid=58cdad&efg=eyJ2ZW5jb2RlX3RhZyI6InhwaWRzLjEzNTB4MTY4Ny5zZHIuQzMifQ%3D%3D&_nc_ohc=Lo82NI0U7yoQ7kNvwFbOTMG&_nc_oc=Adnk0Cm4Fz_y9umiyqy4Jr3B6WzGcfX28D7qHYHUj5NsWknX-zFWhYUNTBFhWP3KMGQ&_nc_ad=z-m&_nc_cid=0&_nc_zt=23&_nc_ht=instagram.ftlv1-1.fna&_nc_gid=WkXln6kn1HwZLT47QKBEHQ&oh=00_AfunVgwctgxRAJ4hTOne4TMsuh0hZ6hnFw6OXlGLLw7Q5Q&oe=698E4D15",
    bio: "מחזיק בתואר היוקרתי מר ישראל בפיתוח גוף לשנת 2024, מומחה לעיצוב וחיטוב הגוף, ומוסמך וינגייט.״בואו לאתגר את עצמכם, ללמוד דרך חיים חדשה ולהיות מרוצים מול המראה.״"
  }
];

export const heroImages = {
  main: "https://customer-assets.emergentagent.com/job_fitness-zion/artifacts/753jrwpj_image.png",
  secondary: "https://customer-assets.emergentagent.com/job_fitness-zion/artifacts/k89ge9n3_image.png"
};

// Instagram Reels/Videos
export const instagramReels = [
  {
    id: 1,
    url: "https://www.instagram.com/p/DTnlbWDDdR5/",
    embedUrl: "https://www.instagram.com/p/DTnlbWDDdR5/embed",
    description: "אימון בחדר הכושר"
  },
  {
    id: 2,
    url: "https://www.instagram.com/p/DQ6BGsCjOZE/",
    embedUrl: "https://www.instagram.com/p/DQ6BGsCjOZE/embed",
    description: "שיעור קבוצתי"
  }
];
